<script>
	export let left;
	export let top;
    if (window.innerWidth > 768) {
        left = 300;
	    top = 100;
    } else {
        left = 0;
	    top = 0;
    }

	let moving = false;
	function onMouseDown() {
		moving = true;
	}
	function onMouseMove(e) {
		if (moving) {
			left += e.movementX;
			top += e.movementY;
		}
	}
	function onMouseUp() {
		moving = false;
	}
</script>

<style>
	.draggable {
		position: relative;
        display: flex;
        flex-direction: column;
        height: 350px;
        width: 400px;
        background-color: #f4f4f4;
        border: solid 2px #cccccc;
        border-radius: 4px;
        box-shadow: 1px 1px #dbdbdb;
	}
    @media only screen and (max-width: 40em) {
      .draggable {
        position: fixed;
        transform: none;
        width: 100%;
        height: 100%;
        max-width: none;
        max-height: none;
        z-index: 10;
        opacity: 95%;
        
      }
    }
</style>

<section on:mousedown={onMouseDown} style="left: {left}px; top: {top}px;" class="draggable">
	<slot></slot>
</section>

<svelte:window on:mouseup={onMouseUp} on:mousemove={onMouseMove} />